// @ts-ignore
import packageInfo from '../../package.json';
export const environment = {
  production: true,
  apiUrl: 'https://api-vendor.aclarian.com/api/',
  baseUrl: 'https://madeirabeachinvoicing.aclarian.com',
  appName: 'City of Madeira Beach  | VendorV2',
  tokenizationKey: 'PaQmTu-VE6uUF-9V6acY-jecjXr',
  datadogClientToken: 'pub76141e624de25887242aa8bbcf4a29ac',
  datadogApplicationId: '30a128da-0389-4f40-9ca4-9d41cac0f7dc',
  datadogService: 'invoicing_madeirabeach_prod',
  ApiKey: 'lR7@c%g0Vp73sU3i',
  env: 'PROD',
  version: packageInfo.version,
};
